import * as React from 'react';

import {RouteComponentProps} from 'react-router';
import LessonApi from '../modules/lessons/api/LessonApi';
import Lesson from '../modules/lessons/domain/aggregates/lesson/Lesson';
import {Link} from 'react-router-dom';
import Page from './Page';
import Registry from '../global/Registry';
import LessonResultApi from '../modules/lessons/api/LessonResultApi';
import EntityId from '../../foundation/domain/EntityId';
import * as _ from 'lodash';
import ExerciseApi from '../modules/lessons/api/ExerciseApi';
import { Button, Label, Header, Segment, Table, Popup } from 'semantic-ui-react';
import Exercise from '../modules/lessons/domain/aggregates/exercise/Exercise';

interface Props {}

interface State {
	lessons: Lesson[];
	exercisesToReview: Exercise[];
}

export default class LinearPage extends Page<RouteComponentProps<Props>, State> {

	public constructor (props: RouteComponentProps<Props>) {
		super(props);

		this.state = { lessons: [], exercisesToReview: [] };
	}

	async componentWillMount () {
		const [lessons, exercisesToReview] = await Promise.all([
			LessonApi.getInstance().getAll(),
			ExerciseApi.getInstance().getAllToRepeatByUserId(Registry.getInstance().me.getId()),
			LessonResultApi.getInstance().getAllByUserId(Registry.getInstance().me.getId())
		]);

		this.setState({lessons, exercisesToReview});
	}

	protected isLoading (): any {
		return this.state.lessons.length === 0;
	}

	protected renderTitle (): string {
		return 'Brain Brooder - Digital Math & Science Education';
	}

	protected renderDescription (): string {
		return 'Learn Math and Science deeply, by taking small but dense lessons that are followed by intelligently repeated exercises, such that you never forget.';
	}

	protected renderContent () {
		const lessons = this.state.lessons;

		const maxX = _(lessons).maxBy(lesson => lesson.getPosition().getX()).getPosition().getX();
		const maxY = _(lessons).maxBy(lesson => lesson.getPosition().getY()).getPosition().getY();

		const svgWidth = maxX * 500 + 400;
		const svgHeight = maxY * 300 + 200;

		const numberOfExercisesToReview = this.state.exercisesToReview.length;

		const completedColor = '#4183c4';
		// const completedColor = '#6daf6d';
		const nextColor = '#ffffff';
		const incompleteColor = '#808080';

		const typesOfNumbersPrerequisitesDiv = <div>0/3</div>;

		return (
			<div className='lesson'>
				<Header as='h1' inverted>Math and Science</Header>

				<Table inverted selectable>
					<Table.Header>
						<Table.Row>
							<Table.HeaderCell>Lesson</Table.HeaderCell>
							<Table.HeaderCell style={{textAlign: 'right'}}>Prerequisites</Table.HeaderCell>
						</Table.Row>
					</Table.Header>
					<Table.Body>
						<Table.Row>
							<Table.Cell>Introduction to sets</Table.Cell>
							<Table.Cell style={{textAlign: 'right'}}></Table.Cell>
						</Table.Row>
						<Table.Row>
							<Table.Cell>The axiom of extensionality</Table.Cell>
							<Table.Cell style={{textAlign: 'right'}}>0/1</Table.Cell>
						</Table.Row>
						<Table.Row>
							<Table.Cell>Sequences</Table.Cell>
							<Table.Cell style={{textAlign: 'right'}}>0/2</Table.Cell>
						</Table.Row>
						<Table.Row>
							<Table.Cell>Subsets and supersets</Table.Cell>
							<Table.Cell style={{textAlign: 'right'}}>0/2</Table.Cell>
						</Table.Row>
						<Table.Row>
							<Table.Cell>Types of numbers</Table.Cell>
							<Table.Cell style={{textAlign: 'right'}}><div style={{float: 'right'}}><Popup hoverable position='bottom right' trigger={typesOfNumbersPrerequisitesDiv}>
								<Popup.Header>Prerequisites</Popup.Header>
								<Popup.Content>
									<ul>
										<li>Introduction to sets</li>
										<li>The axiom of extensionality</li>
										<li>Subsets and supersets</li>
										<li>Introduction to sets</li>
										<li>The axiom of extensionality</li>
										<li>Subsets and supersets</li>
										<li>Introduction to sets</li>
										<li>The axiom of extensionality</li>
										<li>Subsets and supersets</li>
										<li>Introduction to sets</li>
										<li>The axiom of extensionality</li>
										<li>Subsets and supersets</li>
										<li>Introduction to sets</li>
										<li>The axiom of extensionality</li>
										<li>Subsets and supersets</li>
										<li>Introduction to sets</li>
										<li>The axiom of extensionality</li>
										<li>Subsets and supersets</li>
										<li>Introduction to sets</li>
										<li>The axiom of extensionality</li>
										<li>Subsets and supersets</li>
										<li>Introduction to sets</li>
										<li>The axiom of extensionality</li>
										<li>Subsets and supersets</li>
										<li>Introduction to sets</li>
										<li>The axiom of extensionality</li>
										<li>Subsets and supersets</li>
										<li>Introduction to sets</li>
										<li>The axiom of extensionality</li>
										<li>Subsets and supersets</li>
										<li>Introduction to sets</li>
										<li>The axiom of extensionality</li>
										<li>Subsets and supersets</li>
										<li>Introduction to sets</li>
										<li>The axiom of extensionality</li>
										<li>Subsets and supersets</li>
										<li>Introduction to sets</li>
										<li>The axiom of extensionality</li>
										<li>Subsets and supersets</li>
										<li>Introduction to sets</li>
										<li>The axiom of extensionality</li>
										<li>Subsets and supersets</li>
										<li>Introduction to sets</li>
										<li>The axiom of extensionality</li>
										<li>Subsets and supersets</li>
										<li>Introduction to sets</li>
										<li>The axiom of extensionality</li>
										<li>Subsets and supersets</li>
										<li>Introduction to sets</li>
										<li>The axiom of extensionality</li>
										<li>Subsets and supersets</li>
										<li>Introduction to sets</li>
										<li>The axiom of extensionality</li>
										<li>Subsets and supersets</li>
										<li>Introduction to sets</li>
										<li>The axiom of extensionality</li>
										<li>Subsets and supersets</li>
										<li>Introduction to sets</li>
										<li>The axiom of extensionality</li>
										<li>Subsets and supersets</li>
										<li>Introduction to sets</li>
										<li>The axiom of extensionality</li>
										<li>Subsets and supersets</li>
										<li>Introduction to sets</li>
										<li>The axiom of extensionality</li>
										<li>Subsets and supersets</li>
										<li>Introduction to sets</li>
										<li>The axiom of extensionality</li>
										<li>Subsets and supersets</li>
										<li>Introduction to sets</li>
										<li>The axiom of extensionality</li>
										<li>Subsets and supersets</li>
										<li>Introduction to sets</li>
										<li>The axiom of extensionality</li>
										<li>Subsets and supersets</li>
										<li>Introduction to sets</li>
										<li>The axiom of extensionality</li>
										<li>Subsets and supersets</li>
										<li>Introduction to sets</li>
										<li>The axiom of extensionality</li>
										<li>Subsets and supersets</li>
										<li>Introduction to sets</li>
										<li>The axiom of extensionality</li>
										<li>Subsets and supersets</li>
										<li>Introduction to sets</li>
										<li>The axiom of extensionality</li>
										<li>Subsets and supersets</li>
									</ul>
								</Popup.Content>
							</Popup></div></Table.Cell>
						</Table.Row>
						<Table.Row>
							<Table.Cell>Functions</Table.Cell>
							<Table.Cell style={{textAlign: 'right'}}>0/4</Table.Cell>
						</Table.Row>
						<Table.Row>
							<Table.Cell>Set-builder notation</Table.Cell>
							<Table.Cell style={{textAlign: 'right'}}>0/6</Table.Cell>
						</Table.Row>
						<Table.Row>
							<Table.Cell>Union and intersection</Table.Cell>
							<Table.Cell style={{textAlign: 'right'}}>0/7</Table.Cell>
						</Table.Row>
						<Table.Row>
							<Table.Cell>Cartesian product</Table.Cell>
							<Table.Cell style={{textAlign: 'right'}}>0/7</Table.Cell>
						</Table.Row>
						<Table.Row>
							<Table.Cell>Complements</Table.Cell>
							<Table.Cell style={{textAlign: 'right'}}>0/8</Table.Cell>
						</Table.Row>
						<Table.Row>
							<Table.Cell>Domain and range</Table.Cell>
							<Table.Cell style={{textAlign: 'right'}}>0/8</Table.Cell>
						</Table.Row>
						<Table.Row>
							<Table.Cell>Properties and relations</Table.Cell>
							<Table.Cell style={{textAlign: 'right'}}>0/9</Table.Cell>
						</Table.Row>
						<Table.Row>
							<Table.Cell>Properties of operations</Table.Cell>
							<Table.Cell style={{textAlign: 'right'}}>0/12</Table.Cell>
						</Table.Row>
						<Table.Row>
							<Table.Cell>Properties of relations</Table.Cell>
							<Table.Cell style={{textAlign: 'right'}}>0/13</Table.Cell>
						</Table.Row>
					</Table.Body>
				</Table>
			</div>
		);
	}
}

interface LessonProps {
	lesson: Lesson;
}

function isCompleted (lessonId: EntityId<Lesson>) {
	const lessonResult = Registry.getInstance().lessonResultRepository.getByUserIdAndLessonId(Registry.getInstance().me.getId(), lessonId);
	return lessonResult !== undefined && lessonResult.isCompleted();
}

function getLessonStatus (lesson: Lesson) {

	if (isCompleted(lesson.getId())) {
		return 'completed';
	}

	if (lesson.getPrerequisiteLessonIds().every(lessonId => isCompleted(lessonId))) {
		return 'next';
	}

	return 'incomplete';
}

function LessonComponent (props: LessonProps) {

	const lesson = props.lesson;

	return (
		<Link className={'lesson ' + getLessonStatus(lesson)} to={lesson.getSlug()} style={{ left: lesson.getPosition().getX() * 500, top: lesson.getPosition().getY() * 300}}>
			<div>
				<div className='header'>
					{lesson.getTitle()}
				</div>
				<div className='content'>
					{lesson.getSubtitle()}
				</div>
			</div>
		</Link>
	);
}

interface ConnectionProps {
	from: Lesson;
	to: Lesson;
}

function ConnectionComponent (props: ConnectionProps) {

	const fromLesson = props.from;
	const toLesson = props.to;

	const x1 = fromLesson.getPosition().getX() * 500 + 200;
	const y1 = fromLesson.getPosition().getY() * 300 + 200 - 2;
	const x2 = toLesson.getPosition().getX() * 500 + 200;
	const y2 = toLesson.getPosition().getY() * 300 + 2;

	const fromLessonStatus = getLessonStatus(fromLesson);
	const toLessonStatus = getLessonStatus(toLesson);

	const topColor = fromLessonStatus === 'incomplete' ? '#808080' : fromLessonStatus === 'next' ? '#ffffff' : '#4183c4';
	const bottomColor = toLessonStatus === 'incomplete' ? '#808080' : toLessonStatus === 'next' ? '#ffffff' : '#4183c4';

	return (
		<g>
			<line x1={x1} y1={y1} x2={x2 + 0.001} y2={y2 + 0.001} strokeWidth='4' stroke={'url(#' + fromLessonStatus + '-to-' + toLessonStatus + ')'} />
			<circle cx={x1} cy={y1} r={8} stroke={topColor} fillOpacity='1' strokeWidth='4' fill='#1D1D1D' />
			<circle cx={x2} cy={y2} r={8} stroke={bottomColor} fillOpacity='1' strokeWidth='4' fill='#1D1D1D' />
		</g>
	);
}


// WEBPACK FOOTER //
// ./code/project/pages/LinearPage.tsx